import styled from '@emotion/styled';

export const LoaderContainer = styled.div`
  display: flex;
  padding: 1rem;
  height: ${(props) => (props.fullScreen ? '80vh' : 'auto')};
  justify-content: center;
  align-items: center;

  .loader {
    width: 48px;
    height: 48px;
    display: inline-block;
    position: relative;
    transform: rotate(45deg);
  }
  .loader::before {
    content: '';
    box-sizing: border-box;
    width: 24px;
    height: 24px;
    position: absolute;
    left: 0;
    top: -24px;
    animation: animloader 4s ease infinite;
  }
  .loader::after {
    content: '';
    box-sizing: border-box;
    position: absolute;
    left: 0;
    top: 0;
    width: 24px;
    height: 24px;
    background: #c40818;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
    animation: animloader2 2s ease infinite;
  }

  @keyframes animloader {
    0% {
      box-shadow: 0 24px #ffa4a4, 24px 24px #ffa4a4, 24px 48px #ffa4a4, 0px 48px #ffa4a4;
    }
    12% {
      box-shadow: 0 24px #feebed, 24px 24px #ffa4a4, 24px 48px #ffa4a4, 0px 48px #ffa4a4;
    }
    25% {
      box-shadow: 0 24px #feebed, 24px 24px #feebed, 24px 48px #ffa4a4, 0px 48px #ffa4a4;
    }
    37% {
      box-shadow: 0 24px #feebed, 24px 24px #feebed, 24px 48px #feebed, 0px 48px #ffa4a4;
    }
    50% {
      box-shadow: 0 24px #feebed, 24px 24px #feebed, 24px 48px #feebed, 0px 48px #feebed;
    }
    62% {
      box-shadow: 0 24px #ffa4a4, 24px 24px #feebed, 24px 48px #feebed, 0px 48px #feebed;
    }
    75% {
      box-shadow: 0 24px #ffa4a4, 24px 24px #ffa4a4, 24px 48px #feebed, 0px 48px #feebed;
    }
    87% {
      box-shadow: 0 24px #ffa4a4, 24px 24px #ffa4a4, 24px 48px #ffa4a4, 0px 48px #feebed;
    }
    100% {
      box-shadow: 0 24px #ffa4a4, 24px 24px #ffa4a4, 24px 48px #ffa4a4, 0px 48px #ffa4a4;
    }
  }

  @keyframes animloader2 {
    0% {
      transform: translate(0, 0) rotateX(0) rotateY(0);
    }
    25% {
      transform: translate(100%, 0) rotateX(0) rotateY(180deg);
    }
    50% {
      transform: translate(100%, 100%) rotateX(-180deg) rotateY(180deg);
    }
    75% {
      transform: translate(0, 100%) rotateX(-180deg) rotateY(360deg);
    }
    100% {
      transform: translate(0, 0) rotateX(0) rotateY(360deg);
    }
  }
`;
